export default __webpack_public_path__ + "static/media/Smaaash.5445c349.webp";